/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ExpertVerificationResponseDto = {
    /**
     * Expert ID
     */
    id: string;
    /**
     * Updated verification status
     */
    verificationStatus: ExpertVerificationResponseDto.verificationStatus;
    /**
     * When the expert was verified
     */
    verifiedAt: Record<string, any> | null;
    /**
     * Admin ID who performed verification
     */
    verifiedBy: Record<string, any> | null;
    /**
     * Verification notes
     */
    verificationNotes: Record<string, any> | null;
};
export namespace ExpertVerificationResponseDto {
    /**
     * Updated verification status
     */
    export enum verificationStatus {
        PENDING = 'pending',
        IN_PROGRESS = 'in_progress',
        VERIFIED = 'verified',
        REJECTED = 'rejected',
        RESUBMISSION_REQUIRED = 'resubmission_required',
    }
}

